/* @flow */

import * as React from 'react';

import type { UserInfo } from '../../redux/appRegistration/types/types';

import Localizer from '../../helpers/localization';
import { Messenger, MessengerEvents } from '../../helpers/messenger';
import { PendingOperationKind, PendingOperationReason, storePendingOperation } from '../../helpers/rights/pendingOperations';
import { hasActiveSubscription } from '../../helpers/rights/userInfo';

export type SubscriptionButtonPropType = {
  +isButtonDisplayed: boolean,
  +isRegisteredAsGuest: boolean,
  +userInfo: UserInfo | null,
};

const SubscriptionButton = ({ isButtonDisplayed, isRegisteredAsGuest, userInfo }: SubscriptionButtonPropType): React.Node => {
  const onClickHandler = React.useCallback(() => {
    if (!isRegisteredAsGuest) {
      // User logged in: display subscription screen
      Messenger.emit(MessengerEvents.SHOW_SUBSCRIBE);
      return;
    }

    // User not logged in: display login screen
    storePendingOperation({ operationType: PendingOperationKind.Subscribe, reason: PendingOperationReason.RequireAccount });
    Messenger.emit(MessengerEvents.SHOW_SIGN_IN, PendingOperationKind.Subscribe);
  }, [isRegisteredAsGuest]);

  if (!isButtonDisplayed) {
    return null;
  }

  if (userInfo) {
    const { subscriptions } = userInfo;
    if (hasActiveSubscription(subscriptions)) {
      return null;
    }
  }

  return (
    <button className='link' onClick={onClickHandler} type='button'>
      {Localizer.localize('subscription.subscribe_button')}
    </button>
  );
};

export default SubscriptionButton;
